import React from "react";

export const RowWithSubtext = (
    rowData: any,
    mainField: string,
    subField: string
) => {
    const mainValue = rowData[mainField];
    const subValue = rowData[subField];

    return (
        <div className="justify-content-start">
            <div>
                <p>{mainValue}</p>
                <small>{subValue}</small>
            </div>
        </div>
    );
};
